import React, { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import styled, { keyframes } from "styled-components";

const Context = React.createContext();

export function ModalProvider({ children }) {
  const modalRef = React.useRef();
  const openState = React.useState(false);
  const [isOpen, setIsOpen] = openState;
  const [modalNode, setModalNode] = React.useState();

  // make sure re-render is triggered after initial
  // render so that modalRef exists
  useEffect(() => {
    setModalNode(modalRef.current);
  }, []);

  return (
    <>
      <Context.Provider value={{ modalNode, openState }}>
        <Content isOpen={isOpen}>{children}</Content>
      </Context.Provider>
      <div ref={modalRef} />
    </>
  );
}

export default function Modal({ onClose, children, ...props }) {
  const { modalNode, openState } = useContext(Context);
  const [isOpen, setIsOpen] = openState;

  useEffect(() => {
    setIsOpen(true);
    return () => {
      setIsOpen(false);
    };
  }, []);

  return modalNode
    ? ReactDOM.createPortal(<Overlay>{children}</Overlay>, modalNode)
    : null;
}

const fadeIn = keyframes`from { opacity: 0; }`;

const Content = styled.div`
  ${({ isOpen }) =>
    isOpen &&
    `
    filter: blur(5px);
    -webkit-filter: blur(5px);
  `}
`;

const Overlay = styled.div`
  animation: ${fadeIn} 200ms ease-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;
